/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_DescriptionInputs */

const en_landing_faq_description = /** @type {(inputs: Landing_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you need to know before getting started.`)
};

const zh_landing_faq_description = /** @type {(inputs: Landing_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始之前你可能想了解的一切。`)
};

/**
* | output |
* | --- |
* | "Everything you need to know before getting started." |
*
* @param {Landing_Faq_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_description = /** @type {((inputs?: Landing_Faq_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_description(inputs)
	return zh_landing_faq_description(inputs)
});
export { landing_faq_description as "landing.faq.description" }